export default __webpack_public_path__ + "static/media/vectorLD.6b927c60.svg";